module.exports = __webpack_public_path__ + "static/img/23-business-cinematic.5cc49be.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-business-cinematic.png
// module id = IKUb
// module chunks = 1